<template>
    <div class="container" v-if="course">
        <el-row :gutter="20">
            <el-col :span="12">
                <img :src="course.courseImg" class="courseImg">
            </el-col>
            <el-col :span="12">
                <span class="publicCourse" v-if="course.isPublic == 0">公开课</span>
                <span class="privateCourse" v-if="course.isPublic == 1">私有课</span>
                <span class="font_1">{{ course.courseName }}</span>
                <br>
                <div class="font_2">开课时间：{{ formatDate(course.createTime) }}</div>
                <div class="font_2" v-if="course.teacher">
                  主讲人：{{ course.teacher.nickName }}
                  <br>
                  <img :src="course.teacher.avatar" class="teacherImg">
                </div>
                <div class="font_2">
                  已有 {{ course.headCount }} 人参加
                </div>
            </el-col>
        </el-row>
    </div>
   
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import $ from 'jquery';

const Route = useRoute(); //获取到值
const courseId = ref("");
let course = ref(null);


onMounted(() => {
  courseId.value = Route.params.courseId;
  pullCourse(courseId.value);
});


const pullCourse = (id) => {
    $.ajax({
    url: "http://124.222.105.205:5000/get/api/course/getCourseById",
    data: {
        courseId: id
    },
    type: "post",
    success(resp) {
      course.value = resp.data;

      if (resp.code != "200") {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
        ElMessage({
          type: "error",
          message: "获取课程失败",
        });
    },
  });
}

const formatDate = (dateTime) => {
      // 将传入的日期时间字符串转换为Date对象
      const date = new Date(dateTime);
      // 使用Date对象的方法获取年月日
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并且补0
      const day = String(date.getDate()).padStart(2, '0'); // 补0
      // 返回格式化后的日期字符串，不包含时分秒
      return `${year}-${month}-${day}`;
    }

</script>

<style scoped>
    .courseImg {
        width: 600px;
        border-radius: 30px;
    }

    .publicCourse {
    width: auto; /* Adjust width based on content */
    padding: 5px; /* Add padding for better appearance */
    font-size: 15px; /* Decrease font size */
    color: rgba(243, 160, 35, 0.97); /* Set text color */
    border-radius: 5px; /* Add border radius for rounded corners */
    border: 1.5px solid rgba(243, 160, 35, 0.97);
}

.privateCourse {
    width: auto; /* Adjust width based on content */
    padding: 5px; /* Add padding for better appearance */
    font-size: 15px; /* Decrease font size */
    color: rgba(165, 66, 196, 0.97);  /* Set text color */
    border-radius: 5%; /* Add border radius for rounded corners */
    border: 1.5px solid rgba(165, 66, 196, 0.97);
}

.font_1 {
    font-weight: bolder;
    font-size: 30px;
    margin: 5px;
}

.font_2 {
    margin: 25px 0px;
    color: rgb(88, 88, 88);
}

.teacherImg {
    width: 100px;
    border-radius: 100px;
}

</style>